export default __webpack_public_path__ + "static/tim-douglas-signjpg-34ff1e9a1a07250e5fc31182f602b2fe.jpg";